import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Stack,
  Avatar
} from '@mui/material';
import GroupIcon from '@mui/icons-material/Group'; // グループ感を出す

interface GroupData {
  id: string;
  name: string;
}

const GroupSelectList: React.FC = () => {
  const [groupList, setGroupList] = useState<GroupData[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem('group-list');
    if (saved) {
      setGroupList(JSON.parse(saved));
    }
  }, []);

  const handleGroupClick = (groupId: string) => {
    navigate(`/select/${groupId}`);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        グループを選択
      </Typography>

      <Box
        display="flex"
        flexWrap="wrap"
        gap={3}
        mt={3}
        justifyContent="flex-start"
      >
        {groupList.map((group) => (
          <Box
            key={group.id}
            width={{ xs: '100%', sm: '48%', md: '30%' }}
            sx={{ display: 'flex' }}
          >
            <Card
              elevation={3}
              sx={{
                flex: 1,
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6,
                },
                borderRadius: 2,
              }}
            >
              <CardActionArea onClick={() => handleGroupClick(group.id)} sx={{ p: 2, height: '100%' }}>
                <Stack spacing={2} alignItems="center">
                  <Avatar sx={{ bgcolor: 'primary.main' }}>
                    <GroupIcon />
                  </Avatar>
                  <Typography variant="h6" align="center" fontWeight="medium">
                    {group.name}
                  </Typography>
                </Stack>
              </CardActionArea>
            </Card>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default GroupSelectList;
